module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.408a4cc6.svg";